// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_e5-3";
export var flatBottomCorners = "_e5-5";
export var productImage = "_e5-0";
export var quantityContainer = "_e5-2";
export var quantityHeader = "_e5-6";
export var tooltip = "_e5-1";
export var wrapAndEllipsesOverflow = "_e5-4";